import { Struct, str, Vector } from 'scale-ts';
import { docs } from './docs.mjs';
import '../../utils/ss58-util.mjs';
import '../scale/Binary.mjs';
import '../scale/bitSequence.mjs';
import '../scale/char.mjs';
import { compactNumber } from '../scale/compact.mjs';
import '../scale/Hex.mjs';
import '../scale/fixed-str.mjs';
import '../scale/Variant.mjs';
import '../scale/ethAccount.mjs';

const runtimeApi = Struct({
  name: str,
  methods: Vector(
    Struct({
      name: str,
      inputs: Vector(
        Struct({
          name: str,
          type: compactNumber
        })
      ),
      output: compactNumber,
      docs
    })
  ),
  docs
});

export { runtimeApi };
//# sourceMappingURL=runtime-api.mjs.map
